// extracted by mini-css-extract-plugin
module.exports = {"menuText":"#4E5969","menuActiveText":"#165DFF","subMenuActiveText":"#165DFF","menuBg":"#fff","menuHover":"#ECEFF6","subMenuBg":"#fff","subMenuHover":"#F7F8FA","sideBarWidth":"180px"};
    if(module.hot) {
      // 1793786751868
      var cssReload = require("E:/zhenzhaopin/xxh-zhaopin-web/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../../","locals":true});
      module.hot.dispose(cssReload);
      
    }
  